<template>
  <div class="task-exam-result-page">
    <CommonHeader />

    <main class="result-page-main">
      <div class="result-page-container">
        <section v-if="!resultReady" class="result-card result-card--loading">
          <div class="result-loading-card__icon">
            <i class="el-icon-loading"></i>
          </div>
          <div class="result-loading-card__title">考试结果加载中</div>
          <div class="result-loading-card__desc">正在同步本次考试成绩与答题明细，请稍候...</div>
        </section>

        <section v-else class="result-card">
          <div :class="['result-badge', badgeClass]">
            <i :class="badgeIcon"></i>
          </div>

          <h1 class="result-title">{{ resultTitle }}</h1>

          <div class="result-score-wrap">
            <span class="result-score">{{ scoreDisplay }}</span>
            <span class="result-score-unit">分</span>
          </div>

          <div :class="['result-message', messageClass]">
            <i :class="messageIcon"></i>
            <span>{{ resultMessage }}</span>
          </div>

          <div class="result-metrics">
            <div class="result-metric-item result-metric-item--split">
              <div class="result-metric-label">{{ primaryMetricLabel }}</div>
              <div class="result-metric-value">{{ primaryMetricValue }}</div>
            </div>
            <div class="result-metric-item">
              <div class="result-metric-label">{{ secondaryMetricLabel }}</div>
              <div class="result-metric-value">{{ secondaryMetricValue }}</div>
            </div>
          </div>

          <div v-if="showPendingReview" class="result-review-tip">
            <i class="el-icon-info"></i>
            <span>{{ pendingReviewTip }}</span>
          </div>

          <div class="result-actions">
            <el-button
              round
              plain
              class="result-actions__btn result-actions__btn--secondary"
              icon="el-icon-data-analysis"
              :disabled="wrongCount === 0"
              @click="goAnalysisPage"
            >
              查看错题解析
            </el-button>
            <el-button
              round
              type="primary"
              class="result-actions__btn result-actions__btn--primary"
              @click="goTaskList"
            >
              返回学习中心
            </el-button>
          </div>

          <div class="result-footer-note">
            <i class="el-icon-info"></i>
            <span>考试记录已同步至您的个人档案</span>
          </div>
        </section>
      </div>
    </main>

    <footer class="result-page-footer">
      <div class="result-page-footer__inner">
        <div class="result-page-footer__left">© 2024 智学云平台。保留所有权利。</div>
        <div class="result-page-footer__links">
          <a href="javascript:void(0)">帮助中心</a>
          <a href="javascript:void(0)">服务条款</a>
          <a href="javascript:void(0)">隐私政策</a>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import CommonHeader from '@/components/header/CommonHeader.vue'
import { getApeTestResult } from '../../api/api'

export default {
  name: 'TaskExamResult',
  components: {
    CommonHeader
  },
  data() {
    return {
      id: '',
      assign: [],
      test: {},
      total: 0,
      defen: 0,
      correctCount: 0,
      wrongCount: 0,
      scoredCount: 0,
      passScore: 60,
      reviewStatus: '无需阅卷',
      pendingManualCount: 0,
      finalScoreReady: true,
      pageLoading: false,
      resultReady: false
    }
  },
  computed: {
    resultTitle() {
      const taskName = this.test.taskName || this.test.name || '考试结果'
      return `${taskName} - 考试结果`
    },
    passScoreValue() {
      return Number(this.passScore || this.$route.query.passScore || 60)
    },
    passed() {
      return this.finalScoreReady && Number(this.defen || 0) >= this.passScoreValue
    },
    scoreDisplay() {
      return Number(this.defen || 0)
    },
    showPendingReview() {
      return !this.finalScoreReady && this.pendingManualCount > 0
    },
    badgeClass() {
      if (this.showPendingReview) {
        return 'result-badge--info'
      }
      return this.passed ? 'result-badge--success' : 'result-badge--warning'
    },
    badgeIcon() {
      if (this.showPendingReview) {
        return 'el-icon-time'
      }
      return this.passed ? 'el-icon-success' : 'el-icon-warning'
    },
    messageClass() {
      if (this.showPendingReview) {
        return 'result-message--info'
      }
      return this.passed ? 'result-message--success' : 'result-message--warning'
    },
    messageIcon() {
      if (this.showPendingReview) {
        return 'el-icon-info'
      }
      return this.passed ? 'el-icon-success' : 'el-icon-warning-outline'
    },
    resultMessage() {
      if (this.showPendingReview) {
        return '当前成绩为已判分题目得分，人工阅卷完成后将展示总分。'
      }
      return this.passed ? '恭喜您，已通过考试！' : '本次考试未通过，请查看错题解析后再试。'
    },
    primaryMetricLabel() {
      return this.showPendingReview ? '已判题数' : '正确题数'
    },
    primaryMetricValue() {
      return `${this.showPendingReview ? this.scoredCount : this.correctCount}/${this.assign.length}`
    },
    secondaryMetricLabel() {
      return this.showPendingReview ? '待阅卷题数' : '错题数量'
    },
    secondaryMetricValue() {
      return this.showPendingReview ? this.pendingManualCount : this.wrongCount
    },
    pendingReviewTip() {
      return `当前显示的 ${this.scoreDisplay} 分仅统计已完成判分的题目，剩余 ${this.pendingManualCount} 道计算题待管理员阅卷后展示最终总分。`
    }
  },
  methods: {
    goTaskList() {
      this.$router.push(this.$route.query.fromTask === '1' ? '/center/tasks' : '/test')
    },
    goAnalysisPage() {
      this.$router.push({ path: '/testAnalysis', query: { id: this.id, fromTask: this.$route.query.fromTask || '1' } })
    },
    getApeTestResult() {
      if (!this.id) {
        this.resultReady = true
        return
      }
      this.pageLoading = true
      getApeTestResult({ id: this.id }).then(res => {
        if (res.code === 1000) {
          this.assign = res.data.testItem || []
          this.test = res.data.test || {}
          this.total = Number(res.data.totalScore || 0)
          this.defen = Number(res.data.totalGetScore || 0)
          this.correctCount = Number(res.data.correctCount || 0)
          this.wrongCount = Number(res.data.wrongCount || 0)
          this.scoredCount = Number(res.data.scoredCount || 0)
          this.passScore = Number(this.$route.query.passScore || res.data.passScore || 60)
          this.reviewStatus = res.data.reviewStatus || '无需阅卷'
          this.pendingManualCount = Number(res.data.pendingManualCount || 0)
          this.finalScoreReady = Boolean(res.data.finalScoreReady)
          this.assign.forEach(item => {
            if (String(item.type) === '0' || String(item.type) === '1') {
              if (item.content) {
                item.content = JSON.parse(item.content)
              }
              if (String(item.type) === '1') {
                item.solution = item.solution ? item.solution.split(',') : []
              }
            }
          })
        } else {
          this.$message.warning(res.message || '考试结果加载失败')
        }
      }).catch(() => {
        this.$message.error('考试结果加载失败')
      }).finally(() => {
        this.pageLoading = false
        this.resultReady = true
      })
    }
  },
  mounted() {
    this.id = this.$route.query.id || ''
    this.getApeTestResult()
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
}
</script>

<style scoped>
.task-exam-result-page {
  min-height: 100vh;
  background: #eef1f5;
  display: flex;
  flex-direction: column;
}

.result-page-main {
  flex: 1;
  padding: 56px 24px 72px;
}

.result-page-container {
  width: min(100%, 860px);
  margin: 0 auto;
}

.result-card {
  background: #fff;
  border-radius: 24px;
  box-shadow: 0 14px 36px rgba(15, 23, 42, 0.08);
  padding: 44px 72px 26px;
  text-align: center;
}

.result-card--loading {
  min-height: 420px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.result-loading-card__icon {
  font-size: 40px;
  color: #3d73f5;
  margin-bottom: 14px;
}

.result-loading-card__title {
  font-size: 26px;
  font-weight: 700;
  color: #1f2d3d;
}

.result-loading-card__desc {
  margin-top: 10px;
  color: #8a94a6;
  font-size: 14px;
}

.result-badge {
  width: 56px;
  height: 56px;
  margin: 0 auto;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
}

.result-badge--success {
  background: #e9f1ff;
  color: #3d73f5;
}

.result-badge--warning {
  background: #fff4e5;
  color: #f59e0b;
}

.result-badge--info {
  background: #eef4ff;
  color: #3d73f5;
}

.result-title {
  margin: 28px 0 0;
  font-size: 28px;
  line-height: 1.45;
  font-weight: 700;
  color: #1f2d3d;
}

.result-score-wrap {
  margin-top: 22px;
  display: inline-flex;
  align-items: flex-end;
  gap: 8px;
}

.result-score {
  font-size: 76px;
  line-height: 1;
  font-weight: 800;
  color: #3d73f5;
  letter-spacing: -0.04em;
}

.result-score-unit {
  padding-bottom: 10px;
  font-size: 24px;
  color: #9aa4b2;
  font-weight: 700;
}

.result-message {
  margin-top: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 700;
}

.result-message--success {
  color: #1fb55c;
}

.result-message--warning {
  color: #f59e0b;
}

.result-message--info {
  color: #3d73f5;
}

.result-metrics {
  width: min(100%, 520px);
  margin: 38px auto 0;
  padding: 20px 0;
  border-top: 1px solid #eef1f5;
  border-bottom: 1px solid #eef1f5;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.result-metric-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.result-metric-item--split {
  border-right: 1px solid #eef1f5;
}

.result-metric-label {
  font-size: 13px;
  color: #9aa4b2;
}

.result-metric-value {
  font-size: 26px;
  color: #1f2d3d;
  font-weight: 700;
}

.result-review-tip {
  margin: 20px auto 0;
  width: min(100%, 560px);
  padding: 14px 16px;
  border-radius: 16px;
  background: #f6f9ff;
  border: 1px solid #dbe7ff;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 8px;
  color: #4f6480;
  font-size: 13px;
  line-height: 1.8;
  text-align: left;
}

.result-actions {
  margin-top: 30px;
  display: flex;
  justify-content: center;
  gap: 14px;
  flex-wrap: wrap;
}

.result-actions__btn {
  min-width: 156px;
  height: 46px;
  font-size: 15px;
  font-weight: 600;
}

.result-actions__btn--secondary {
  background: #eef4ff;
  border-color: #eef4ff;
  color: #3d73f5;
}

.result-actions__btn--secondary:hover,
.result-actions__btn--secondary:focus {
  background: #e2edff;
  border-color: #e2edff;
  color: #315fd0;
}

.result-actions__btn--primary {
  background: linear-gradient(135deg, #4f7cff 0%, #2f67ff 100%);
  border: 0;
  box-shadow: 0 10px 20px rgba(47, 103, 255, 0.24);
}

.result-footer-note {
  margin: 34px -72px -26px;
  min-height: 58px;
  border-top: 1px solid #eef1f5;
  background: #fafbfd;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #8a94a6;
  font-size: 12px;
}

.result-page-footer {
  border-top: 1px solid #e5e7eb;
  background: #fff;
}

.result-page-footer__inner {
  width: min(100%, 1200px);
  margin: 0 auto;
  padding: 20px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  color: #7b8794;
  font-size: 13px;
}

.result-page-footer__links {
  display: flex;
  align-items: center;
  gap: 22px;
}

.result-page-footer__links a {
  color: #7b8794;
  text-decoration: none;
}

.result-page-footer__links a:hover {
  color: #3d73f5;
}

@media (max-width: 768px) {
  .result-page-main {
    padding: 28px 16px 40px;
  }

  .result-card {
    padding: 30px 20px 20px;
  }

  .result-title {
    font-size: 22px;
  }

  .result-score {
    font-size: 58px;
  }

  .result-score-unit {
    font-size: 20px;
    padding-bottom: 8px;
  }

  .result-message {
    font-size: 15px;
    line-height: 1.6;
  }

  .result-metrics {
    grid-template-columns: 1fr;
    gap: 18px;
  }

  .result-metric-item--split {
    border-right: 0;
    border-bottom: 1px solid #eef1f5;
    padding-bottom: 18px;
  }

  .result-review-tip {
    width: 100%;
  }

  .result-actions {
    flex-direction: column;
  }

  .result-actions__btn {
    width: 100%;
  }

  .result-footer-note {
    margin-left: -20px;
    margin-right: -20px;
  }

  .result-page-footer__inner {
    flex-direction: column;
  }
}
</style>
